// @flow
import React, { type Node } from 'react';

import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './Task.scss';


type Props = {
  taskDescription: string,
  children: Node,
}

const Task = ({ taskDescription, children }: Props): Node => {
  return (
    <div className={styles.root}>
      <PlainTooltip
        text={taskDescription}
        className={styles.taskDescription}
        hideWithoutOverflow
      >
        {taskDescription}
      </PlainTooltip>

      {children}
    </div>
  );
};

export default Task;
